import { Box, TextField, Typography } from "@mui/material"

export function RuleJustificationField({ value, onChange }) {
    return (
        <Box>
            <Typography
                variant="subtitle2"
                color="text.primary"
                fontWeight={700}
                sx={{ mb: 1.5, display: "block", fontSize: 16 }}
            >
                Justification
            </Typography>
            <TextField
                fullWidth
                multiline
                minRows={2}
                size="small"
                placeholder="Explain why this change is being made…"
                value={value || ""}
                onChange={handleChange}
                data-cy="rule-justification"
            />
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.75 }}>
                Adding a justification will explain on the resulting schedules why these changes were made.
            </Typography>
        </Box>
    )

    function handleChange(e) {
        onChange?.(e.target.value)
    }
}
